import React, {Component} from 'react';
import { TimeGridItem } from '../TimeGrid';
//import moment  from 'moment';
//import Clinic from '../../api/Clinic';
//import { AppointmentService } from '../../api/Service';
import StatusIcon from '../../components/StatusIcon';
//import User from '../../api/User';
import Appointment from '../../api/Appointment';
//import { SanitizeClassNames } from '../../common';
import { NotificationManager } from 'react-notifications';
//import Clinic from

import Hammer from 'react-hammerjs';
import ColorHelper from "../../classes/ColorHelper";
import {BioTrackPortal} from "../../components/BiopedUI";
import AppointmentViewCard from "./AppointmentViewCard";
import CalendarView from "../CalendarView";
import Icon from "../../components/Icon";

const prefIcon = {
	email: 'email',
	cell: 'text',
	phone: 'call',
	work: 'call',
	PHON: 'call',
	SMSM: 'text',
	EMAL: 'email'
};


export default class CalendarAppointment extends Component{
	static colors = [
		'#F9A14A',
		'#5D4DA1',
		'#C1198B',
		'#42A444'
	];

	state = {};

	setDom = (ref) => {
		this.setState({
			dom: ref
		})
	}


	formatTime(time){

		let format =  'h:mm a';
		if(time.minute() == 0){
			format = 'h a';
		}

		return time.format(format);

	}

	onStart(pos){
		this.oldPos = pos;
	}

	onMove(pos){
		let start = this.props.grid.getTimeFromRow(pos.y);
		let end = this.props.grid.getTimeFromRow(pos.y + pos.h)
		this.setState({timeStart:start, timeEnd:end});
	}

	/*onDrop(pos, isUndo){
		//let start = this.grid.getTimeFromRow(pos.y);
		//let end = this.grid.getTimeFromRow(pos.y + pos.h)
		//this.updateAppTime(start, end);
		console.log('Calendar Appointment Drop!!!!!!!!')
		if(this.props.onUpdateApp){
			this.setState({isBusy:true});
			//let oldApp = JSON.parse(JSON.stringify(this.props.appointment));
			let promise = this.props.onUpdateApp(this.props.appointment, pos);
			if(!promise) {
				this.onDrop(this.oldPos, true)
				this.setState({isBusy:false});
				return;
			}
			promise.then((d)=> {
				console.log('App Update Complete', d);

				for(let p in d){
					this.props.appointment[p] = d[p];
				}
				this.setState({isBusy:false});
				if(!isUndo){
					NotificationManager.success(
						<div>
                            <span className='app-undo-btn' onClick={()=>{
	                            this.onDrop(this.oldPos, true)
                            }}>UNDO
                            </span>
							<div className='notification-close-btn'>x</div>
						</div>

						, 'Appointment Updated!', 5000);

				}else{
					NotificationManager.warning(<div>
						<span>Appointment Reverted!</span>
						<div className='notification-close-btn'>x</div>
					</div>);
				}
			})
		}
	}*/

	setDetailState = (isVisible, delay = 500) => {
		if(this.timeOutId != null){
			clearTimeout(this.timeOutId);
			//this.timeOutId = null;

		}
		this.timeOutId = setTimeout(() => {
			this.setState({showDetails: isVisible});
			this.timeOutId = null;
		}, delay)
	}

	onMouseEnter = (e) => {
		this.setDetailState(true)
	}

	onMouseLeave = (e) => {
		this.setDetailState(false);
	}

	onClickOutside = (x, y) => {
		this.setDetailState(false, 0);
	}

	/**
	 *
	 * @param style - popover container stlye object
	 * @param bounds - target object to follow bounds
	 * @param container - popover container dom ref
	 * @param arrow - popover arrow style ref
	 */
	popoverFunc = (style, bounds, container, arrow) => {
		let cbounds = container.getBoundingClientRect();

		style.left = '';
		style.right = '';

		const offset = 6;

		arrow.display = 'block';

		//console.log('br', bounds.right, 'bw', cbounds.width,'innerWidth', window.innerWidth);

		if((bounds.right + cbounds.width) > window.innerWidth || !cbounds.width){
			style.left = ((bounds.left - offset) - cbounds.width) + 'px';
			arrow.left = '100%';
		} else {
			style.left = (bounds.right + offset) + 'px';
		}

		let top = (bounds.top + (bounds.height/2));

		if((top + cbounds.height/2) > window.innerHeight){
			top -= ((top + cbounds.height/2) - window.innerHeight)
		}

		if((top - cbounds.height/2) < 0){
			top -= (top - cbounds.height/2)
		}


		//style.left = bounds.right + 'px';
		style.top = top + 'px';
		style.transform = 'translateY(-50%)'


		let arrowTop = (bounds.top - top) + bounds.height/2;

		arrow.top = `calc(50% + ${arrowTop}px)` ;

	}

	requestEdit = (app) => {
		CalendarView.ShowEditAppointment(app);
		this.setDetailState(false, 0);
	}

	requestCopy = (app) => {
		CalendarView.CopyAppointment(app);
		this.setDetailState(false, 0);
	}

	requestUserDetails = (user) => {
		CalendarView.ShowUserDetails(user);
		this.setDetailState(false, 0);
	}

	render(){
		//let time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		let time = null;
		let app = new Appointment(this.props.appointment);
		let user = app.client;
		if(this.state.timeStart){
			time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		} else{
			time = Appointment.FormatTimeRange(app);
		}

		let inverse = ColorHelper.GetInverse('#' + app.appointmentType.color);

		let style = {
			backgroundColor:'#' + app.appointmentType.color,
			color: inverse,
			textShadow: "0px 0px 3px " + ColorHelper.GetInverse(inverse)
		}

		let reminder = (app.reminders || [])[0] || {};

		let contactMethod = prefIcon[reminder.notificationTypeCd]; //prefIcon[user.preferredContactMethod];

		const colorClass = inverse === '#ffffff'? 'white': 'black';

		const appDetailIcons = [];
		if(app.comment) {
			appDetailIcons.push(<Icon icon={'notes'} className='rx-notes-icon' />);
		}

		if(app.hasPrescription) {
			appDetailIcons.push(<Icon icon={'rx'} className='rx-notes-icon' />)
		}

		return (
			<div
				key={'App_Cell' + app.appointmentId}
				className="calendar-item" style={style}
				grid-item={this.props['grid-item']}
				ref={this.setDom}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
			>
				<div className="name"><span>{user.fullName}</span><span className={'app-details-icons ' + colorClass}>{ appDetailIcons }</span></div>
				<div className="time">{time}</div>
				<StatusIcon icon={contactMethod} status={app.status}/>

				{this.state.isBusy ? <span className="Select-loading"></span> : null}
				<BioTrackPortal
					className={'app-popover'}
					isVisible={this.state.showDetails}
					target={this.state.dom}
					posFunc={this.popoverFunc}
					onClickOutside={this.onClickOutside}
				>
					<AppointmentViewCard appointment={app} onRequestEdit={this.requestEdit} onRequestCopy={this.requestCopy} onRequestUserDetails={this.requestUserDetails} />
				</BioTrackPortal>
			</div>
		)
	}
}

/*class AppCellView extends Component{

    render(){
        let {app, ...props} = this.props;

        let user = app.client;
        let contactMethod = prefIcon[user.preferredContactMethod];
        let style = {
            backgroundColor: '#' + app.appointmentType.color
        }
        return(
            <div className={SanitizeClassNames(this, 'app-detail')} style={style} {...props}>
                <div className="name">{user.fullName}</div>
                <StatusIcon icon={contactMethod} status={app.status} />
            </div>
        )
    }
}*/



// WEBPACK FOOTER //
// ./src/views/Appointments/CalendarAppointment.js